module.exports = __webpack_public_path__ + "img/usbg.54823aa8.jpg";